import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import type { ReactNode } from 'react'

import cn from '../StockImportsTab/StockImportsTab.module.scss'
import { requiredLabel } from './RequiredLabel'

export const labelWithTooltip = (
  label: string,
  tooltip: ReactNode,
  required = false
) => (
  <span className={cn.labelWithTooltip}>
    {required ? requiredLabel(label) : label}
    <Tooltip title={tooltip} placement="topLeft">
      <QuestionCircleOutlined className={cn.labelHelpIcon} />
    </Tooltip>
  </span>
)
